"use client";

import React from "react";
import EditSection, {
  TextEditor,
} from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function HokContactEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <>
          {/* Header */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Header Settings</h4>
            <TextEditor
              label="Subtitle"
              value={content.subtitle}
              onChange={(v) => handleChange({ ...content, subtitle: v })}
              placeholder="Contact Us"
            />
            <TextEditor
              label="Section Title"
              value={content.title}
              onChange={(v) => handleChange({ ...content, title: v })}
              placeholder="Get in Touch"
            />
            <TextEditor
              label="Description"
              value={content.description}
              onChange={(v) => handleChange({ ...content, description: v })}
              placeholder="We'd love to hear from you."
              multiline
            />
          </div>

          {/* Location details */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Location Details</h4>
            <TextEditor
              label="Title"
              value={content.locationTitle}
              onChange={(v) => handleChange({ ...content, locationTitle: v })}
              placeholder="Our Current Location"
            />
            <TextEditor
              label="Address Text"
              value={content.locationText}
              onChange={(v) => handleChange({ ...content, locationText: v })}
              placeholder="4517 Washington Ave. Manchester..."
              multiline
            />
            <TextEditor
              label="Google Maps URL"
              value={content.locationMapsUrl}
              onChange={(v) => handleChange({ ...content, locationMapsUrl: v })}
              placeholder="https://maps.google.com/?q=..."
            />
          </div>

          {/* Phone Details */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Phone Details</h4>
            <TextEditor
              label="Title"
              value={content.phoneTitle}
              onChange={(v) => handleChange({ ...content, phoneTitle: v })}
              placeholder="Phone Number"
            />
            <TextEditor
              label="Phone Numbers (Line-separated)"
              value={content.phoneText}
              onChange={(v) => handleChange({ ...content, phoneText: v })}
              placeholder="+(00) 12 - 345 6789..."
              multiline
            />
          </div>

          {/* Email Details */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Email Details</h4>
            <TextEditor
              label="Title"
              value={content.emailTitle}
              onChange={(v) => handleChange({ ...content, emailTitle: v })}
              placeholder="Email"
            />
            <TextEditor
              label="Email Addresses (Line-separated)"
              value={content.emailText}
              onChange={(v) => handleChange({ ...content, emailText: v })}
              placeholder="team@example.com..."
              multiline
            />
          </div>
        </>
      }
    />
  );
}
